import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "preview", "previewImage", "fileInput"]

  connect() {
    // Watch for dropzone's auto-generated preview container inside our dropzone wrapper
    this.observer = new MutationObserver(() => this.hideDropzonePreview())
    this.observer.observe(this.dropzoneTarget, { childList: true, subtree: true })

    // The dropzone:file-added event is dispatched on the inner [data-dropzone-target]
    // with bubbles:false, so it won't reach our outer wrapper. Listen directly.
    this.dzElement = this.dropzoneTarget.querySelector("[data-dropzone-target='dropzone']")
    if (this.dzElement) {
      this.boundShowPreview = this.showPreview.bind(this)
      this.dzElement.addEventListener("dropzone:file-added", this.boundShowPreview)
    }
  }

  disconnect() {
    this.observer?.disconnect()
    if (this.dzElement && this.boundShowPreview) {
      this.dzElement.removeEventListener("dropzone:file-added", this.boundShowPreview)
    }
  }

  hideDropzonePreview() {
    // The dropzone controller inserts a preview container (div.flex.flex-wrap)
    // before its dropzone target, inside our wrapper. Remove it from the DOM
    // entirely — setting display:none is insufficient because the dropzone
    // controller re-shows it asynchronously via style.display = 'flex'.
    this.dropzoneTarget.querySelectorAll(":scope > div:not([data-dropzone-target]):not(.flex.justify-center)").forEach((el) => {
      el.remove()
    })
  }

  showPreview(event) {
    const file = event.detail?.file || this.fileInputTarget.files?.[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewImageTarget.src = e.target.result
      this.dropzoneTarget.classList.add("hidden")
      this.previewTarget.classList.remove("hidden")
    }
    reader.readAsDataURL(file)
  }

  clear() {
    this.previewImageTarget.src = ""
    this.previewTarget.classList.add("hidden")
    this.dropzoneTarget.classList.remove("hidden")

    // Clear the file input
    if (this.hasFileInputTarget) {
      this.fileInputTarget.value = ""
    }

    // Remove hidden file inputs created by dropzone controller
    this.element.querySelectorAll("input[type='file'][name='photo[image]']").forEach((input) => {
      if (input !== this.fileInputTarget && input.style.display === "none") {
        input.remove()
      }
    })
  }
}
